/**
 * 二点間の距離を求める
 * @param depPoint 出発地
 * @param arrPoint 到着地
 */
export const computeDistanceBetween = (depPoint: GeoLocation, arrPoint: GeoLocation) => {
  const rad = (deg: number) => {
    return deg * Math.PI / 180;
  }
  const depRedPoint = {
    lat: rad(depPoint.lat),
    lng: rad(depPoint.lng)
  }
  const arrRedPoint = {
    lat: rad(arrPoint.lat),
    lng: rad(arrPoint.lng)
  }

  // 緯度差
  const latDiff = depRedPoint.lat - arrRedPoint.lat;
  // 経度差算
  const lngDiff = depRedPoint.lng - arrRedPoint.lng;
  // 平均緯度
  const latAvg = (depRedPoint.lat + arrRedPoint.lat) / 2.0;
  // 赤道半径
  const equatorRad = 6378137.0;
  // 第一離心率^2
  const e2 = 0.00669438002301188;
  // 赤道上の子午線曲率半径
  const a1e2 = 6335439.32708317;
  const sinLat = Math.sin(latAvg);
  const W2 = 1.0 - e2 * (sinLat * sinLat);
  // 子午線曲率半径M
  const M = a1e2 / (Math.sqrt(W2) * W2);
  // 卯酉線曲率半径
  const N = equatorRad / Math.sqrt(W2);
  const t1 = M * latDiff;
  const t2 = N * Math.cos(latAvg) * lngDiff;
  return Math.sqrt((t1 * t1) + (t2 * t2));
}
/**
 * 駅すぱあとの緯度経度情報より、GeoLocation形に変換する
 */
export const convertEWSToLocation = (baseGeoPoint: EWSGeoPoint): GeoLocation => {
  return {
    lat: Number(baseGeoPoint.lati_d),
    lng: Number(baseGeoPoint.longi_d),
    gcs: baseGeoPoint.gcs
  }
}
/**
 * Location型を駅すぱあとで使える座標情報文字列に変換する
 */
export const convertLocationToStr = (point: GeoLocation): string => {
  return `${point.lat},${point.lng}`;
}

/**
 * 文字列をGeoLocation型に変換する
 * @param point 変換対象の文字
 * @returns
 */
export const convertStrToLocation = (point: string): GeoLocation => {
  const lat = Number(point.split(',')[0]);
  const lng = Number(point.split(',')[1]);
  if(isNaN(lat) || isNaN(lng)) {
    throw new Error(`対象の文字列は座標のフォーマットを満たしていません: ${point}`)
  }
  return {
    lat: lat,
    lng: lng
  }
}

export interface GeoLocation {
  lat: number;
  lng: number;
  gcs?: string;
}

export interface EWSGeoPoint {
  longi: string;
  lati: string;
  longi_d: string;
  lati_d: string;
  gcs: string;
}
